// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Mode Selector ──────────────────────────────────────────────── */

.mode-selector-container {
  pointer-events: none;
}

.mode-selector-container--docked {
  width: 36rem;
  max-width: calc(100vw - 3rem);
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  transform: translateY(-8px);
}

.mode-selector-container--inline {
  pointer-events: auto;
  width: 36rem;
  max-width: 100%;
  flex: 0 0 auto;
}

.mode-selector-container--compact {
  position: relative;
  pointer-events: auto;
  width: max-content;
}

.mode-compact-trigger {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  min-height: 2rem;
  padding: 0.4rem 0.65rem;
  border: 1px solid #d1d5db;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.9);
  color: #374151;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 700;
  box-shadow: none;
  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}

.mode-compact-trigger:hover {
  background: #f9fafb;
  border-color: #9ca3af;
  color: #111827;
}

.mode-compact-trigger__label {
  line-height: 1;
  white-space: nowrap;
}

.mode-compact-trigger__icon {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2.2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.mode-compact-menu {
  position: absolute;
  top: calc(100% + 0.35rem);
  left: 0;
  width: 10.5rem;
  overflow: hidden;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  background: var(--surface-color);
  box-shadow: none;
}

.mode-compact-menu__item {
  display: block;
  width: 100%;
  border: 0;
  background: transparent;
  color: #374151;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.84rem;
  font-weight: 650;
  padding: 0.62rem 0.78rem;
  text-align: left;
}

.mode-compact-menu__item:hover,
.mode-compact-menu__item.active {
  background: #f3f4f6;
  color: #111827;
}

.dark .mode-compact-trigger {
  background: rgba(31, 41, 55, 0.92);
  border-color: #4b5563;
  color: #d1d5db;
  box-shadow: none;
}

.dark .mode-compact-trigger:hover {
  background: #374151;
  border-color: #6b7280;
  color: #f9fafb;
}

.dark .mode-compact-menu {
  background: #1f2937;
  border-color: #4b5563;
  box-shadow: none;
}

.dark .mode-compact-menu__item {
  color: #d1d5db;
}

.dark .mode-compact-menu__item:hover,
.dark .mode-compact-menu__item.active {
  background: #374151;
  color: #f9fafb;
}

.mode-selector-panel {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
  padding: 0.55rem 1rem 0.6rem;
  background: #f3f4f6;
  color: #111827;
  border: 1px solid #d9dde5;
  border-radius: 8px;
  pointer-events: auto;
  box-shadow: 0 2px 7px rgba(15, 23, 42, 0.06);
  white-space: nowrap;
}

.dark .mode-selector-panel {
  background: #1f2937;
  border-color: #3f4654;
  color: #f9fafb;
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.25);
}

.mode-bar-title {
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #4b5563;
  text-align: center;
}

.dark .mode-bar-title {
  color: #cbd5e1;
}

.mode-bar-buttons {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.mode-selector-divider {
  width: 1px;
  height: 1.3rem;
  background: #d1d5db;
  margin: 0 0.2rem;
  flex-shrink: 0;
}

.dark .mode-selector-divider {
  background: #4b5563;
}

.mode-selector-divider--section {
  width: 1px;
  height: 1.5rem;
  background: #c6cbd4;
  margin: 0 0.5rem;
  flex-shrink: 0;
  border-radius: 1px;
}

.dark .mode-selector-divider--section {
  background: #4b5563;
}

.mode-tab {
  padding: 0.45rem 1.1rem;
  border-radius: 6px;
  border: 1px solid transparent;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  color: #4b5563;
  background: transparent;
  transition: all 0.18s ease;
  letter-spacing: 0.01em;
}

.mode-tab:hover:not(:disabled) {
  color: #111827;
  background: #e5e7eb;
  border-color: #d1d5db;
}

.mode-tab.mode-tab-active {
  background: #6b7280;
  border-color: #6b7280;
  color: #fff;
}

.dark .mode-tab {
  color: #cbd5e1;
}

.dark .mode-tab:hover:not(:disabled) {
  color: #f9fafb;
  background: #374151;
  border-color: #4b5563;
}

.dark .mode-tab.mode-tab-active {
  background: #e5e7eb;
  border-color: #e5e7eb;
  color: #111827;
}

.mode-selector-container--inline .mode-selector-panel {
  width: 100%;
  padding: 0.1rem 0 0;
  gap: 0.5rem;
  border: none;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  transform: none;
  transform-origin: center top;
}

.mode-selector-container--docked .mode-selector-panel {
  width: 100%;
  padding: 0.1rem 0 0;
  gap: 0.5rem;
  border: none;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  isolation: isolate;
}

.mode-selector-container--docked .mode-selector-panel::before {
  content: "";
  position: absolute;
  inset: -0.8rem -0.5rem -1.38rem;
  z-index: -1;
  box-sizing: border-box;
  border-radius: 10px 10px 0 0;
  border: 1px solid #e5e7eb;
  border-bottom: 0;
  background: var(--surface-color);
}

.dark .mode-selector-container--docked .mode-selector-panel::before {
  border-color: #374151;
  background: #1f2937;
}

.mode-bar-header {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
}

.mode-bar-header-spacer {
  justify-self: start;
  width: 6rem;
  height: 1px;
}

.mode-bar-toggle-placeholder {
  justify-self: end;
  width: 6rem;
  height: 28px;
}

.mode-selector-container--inline .mode-bar-title,
.mode-selector-container--docked .mode-bar-title {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  font-size: 0.72rem;
  letter-spacing: 0.14em;
  color: #475569;
  white-space: nowrap;
  flex-shrink: 0;
}

.mode-selector-container--inline .mode-bar-title::before,
.mode-selector-container--inline .mode-bar-title::after,
.mode-selector-container--docked .mode-bar-title::before,
.mode-selector-container--docked .mode-bar-title::after {
  content: "";
  display: block;
  flex: 0 0 4.25rem;
  width: 4.25rem;
  height: 1px;
  background: rgba(148, 163, 184, 0.9);
}

.dark .mode-selector-container--inline .mode-bar-title,
.dark .mode-selector-container--docked .mode-bar-title {
  color: #d8e0ea;
}

.dark .mode-selector-container--inline .mode-bar-title::before,
.dark .mode-selector-container--inline .mode-bar-title::after,
.dark .mode-selector-container--docked .mode-bar-title::before,
.dark .mode-selector-container--docked .mode-bar-title::after {
  background: rgba(148, 163, 184, 0.72);
}

.mode-selector-container--inline .mode-bar-buttons,
.mode-selector-container--docked .mode-bar-buttons {
  gap: 0.2rem;
  flex-wrap: nowrap;
  justify-content: center;
  width: 100%;
}

.mode-selector-container--inline .mode-tab,
.mode-selector-container--docked .mode-tab {
  flex: 1 1;
  min-width: 0;
  padding: 0.42rem 0.45rem;
  border-radius: 6px;
  border: 1px solid transparent;
  background: transparent;
  color: #4b5563;
  font-size: clamp(0.76rem, 1.15vw, 0.88rem);
  font-weight: 600;
  letter-spacing: 0.01em;
  white-space: nowrap;
}

.mode-selector-container--inline .mode-tab:hover:not(:disabled),
.mode-selector-container--docked .mode-tab:hover:not(:disabled) {
  color: #111827;
  background: #e5e7eb;
  border-color: #d1d5db;
}

.mode-selector-container--inline .mode-tab.mode-tab-active,
.mode-selector-container--docked .mode-tab.mode-tab-active {
  background: #6b7280;
  border-color: #6b7280;
  color: #fff;
}

.dark .mode-selector-container--inline .mode-tab,
.dark .mode-selector-container--docked .mode-tab {
  color: #cbd5e1;
}

.dark .mode-selector-container--inline .mode-tab:hover:not(:disabled),
.dark .mode-selector-container--docked .mode-tab:hover:not(:disabled) {
  color: #f9fafb;
  background: #374151;
  border-color: #4b5563;
}

.dark .mode-selector-container--inline .mode-tab.mode-tab-active,
.dark .mode-selector-container--docked .mode-tab.mode-tab-active {
  background: #e5e7eb;
  border-color: #e5e7eb;
  color: #111827;
}

.mode-selector-container--inline .mode-selector-divider,
.mode-selector-container--inline .mode-selector-divider--section,
.mode-selector-container--docked .mode-selector-divider,
.mode-selector-container--docked .mode-selector-divider--section {
  display: none;
}

/* ── Toggle button ── */

.mode-bar-toggle {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 6px;
  background: #e5e7eb;
  color: #374151;
  cursor: pointer;
  padding: 0;
  pointer-events: auto;
  transition: all 0.2s ease;
  margin-left: 0.4rem;
}

.mode-bar-toggle:hover {
  background: #d1d5db;
  transform: scale(1.05);
}

.dark .mode-bar-toggle {
  background: #374151;
  color: #d1d5db;
}

.dark .mode-bar-toggle:hover {
  background: #4b5563;
}

.mode-bar-toggle-inline {
  position: static;
  justify-self: start;
  transform: translateX(-1.55rem);
  width: auto;
  height: 28px;
  gap: 0.28rem;
  padding: 0 0.55rem 0 0.5rem;
  margin-left: 0;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.92);
  color: #334155;
  opacity: 1;
}

.mode-bar-toggle-inline:hover {
  background: #eef2f7;
  border-color: #94a3b8;
  color: #0f172a;
  transform: translateX(-1.55rem);
}

.mode-bar-toggle-inline-label {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1;
}

.mode-bar-toggle-inline .collapse-icon {
  width: 14px;
  height: 14px;
}

.dark .mode-bar-toggle-inline {
  background: rgba(30, 41, 59, 0.92);
  border-color: #475569;
  color: #d8e0ea;
}

.dark .mode-bar-toggle-inline:hover {
  background: #334155;
  border-color: #64748b;
  color: #f8fafc;
}

.mode-bar-toggle-collapsed {
  width: auto;
  min-height: 32px;
  padding: 0 0.85rem 0 0.7rem;
  gap: 0.35rem;
  margin-left: 0;
  border-radius: 7px;
}

.mode-bar-toggle-label {
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/ModeSelector.css"],"names":[],"mappings":"AAAA,sEAAsE;;AAEtE;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kFAAkF;AACpF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,OAAO;EACP,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;EAIE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,qCAAqC;AACvC;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;AACb;;AAEA;;EAEE,SAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA,wBAAwB;;AAExB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB","sourcesContent":["/* ── Mode Selector ──────────────────────────────────────────────── */\n\n.mode-selector-container {\n  pointer-events: none;\n}\n\n.mode-selector-container--docked {\n  width: 36rem;\n  max-width: calc(100vw - 3rem);\n  flex: 0 0 auto;\n  display: flex;\n  justify-content: center;\n  transform: translateY(-8px);\n}\n\n.mode-selector-container--inline {\n  pointer-events: auto;\n  width: 36rem;\n  max-width: 100%;\n  flex: 0 0 auto;\n}\n\n.mode-selector-container--compact {\n  position: relative;\n  pointer-events: auto;\n  width: max-content;\n}\n\n.mode-compact-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  min-height: 2rem;\n  padding: 0.4rem 0.65rem;\n  border: 1px solid #d1d5db;\n  border-radius: 9px;\n  background: rgba(255, 255, 255, 0.9);\n  color: #374151;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 0.82rem;\n  font-weight: 700;\n  box-shadow: none;\n  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;\n}\n\n.mode-compact-trigger:hover {\n  background: #f9fafb;\n  border-color: #9ca3af;\n  color: #111827;\n}\n\n.mode-compact-trigger__label {\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.mode-compact-trigger__icon {\n  width: 14px;\n  height: 14px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2.2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.mode-compact-menu {\n  position: absolute;\n  top: calc(100% + 0.35rem);\n  left: 0;\n  width: 10.5rem;\n  overflow: hidden;\n  border: 1px solid #d1d5db;\n  border-radius: 12px;\n  background: var(--surface-color);\n  box-shadow: none;\n}\n\n.mode-compact-menu__item {\n  display: block;\n  width: 100%;\n  border: 0;\n  background: transparent;\n  color: #374151;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 0.84rem;\n  font-weight: 650;\n  padding: 0.62rem 0.78rem;\n  text-align: left;\n}\n\n.mode-compact-menu__item:hover,\n.mode-compact-menu__item.active {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n.dark .mode-compact-trigger {\n  background: rgba(31, 41, 55, 0.92);\n  border-color: #4b5563;\n  color: #d1d5db;\n  box-shadow: none;\n}\n\n.dark .mode-compact-trigger:hover {\n  background: #374151;\n  border-color: #6b7280;\n  color: #f9fafb;\n}\n\n.dark .mode-compact-menu {\n  background: #1f2937;\n  border-color: #4b5563;\n  box-shadow: none;\n}\n\n.dark .mode-compact-menu__item {\n  color: #d1d5db;\n}\n\n.dark .mode-compact-menu__item:hover,\n.dark .mode-compact-menu__item.active {\n  background: #374151;\n  color: #f9fafb;\n}\n\n.mode-selector-panel {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.55rem 1rem 0.6rem;\n  background: #f3f4f6;\n  color: #111827;\n  border: 1px solid #d9dde5;\n  border-radius: 8px;\n  pointer-events: auto;\n  box-shadow: 0 2px 7px rgba(15, 23, 42, 0.06);\n  white-space: nowrap;\n}\n\n.dark .mode-selector-panel {\n  background: #1f2937;\n  border-color: #3f4654;\n  color: #f9fafb;\n  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.25);\n}\n\n.mode-bar-title {\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #4b5563;\n  text-align: center;\n}\n\n.dark .mode-bar-title {\n  color: #cbd5e1;\n}\n\n.mode-bar-buttons {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.mode-selector-divider {\n  width: 1px;\n  height: 1.3rem;\n  background: #d1d5db;\n  margin: 0 0.2rem;\n  flex-shrink: 0;\n}\n\n.dark .mode-selector-divider {\n  background: #4b5563;\n}\n\n.mode-selector-divider--section {\n  width: 1px;\n  height: 1.5rem;\n  background: #c6cbd4;\n  margin: 0 0.5rem;\n  flex-shrink: 0;\n  border-radius: 1px;\n}\n\n.dark .mode-selector-divider--section {\n  background: #4b5563;\n}\n\n.mode-tab {\n  padding: 0.45rem 1.1rem;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  color: #4b5563;\n  background: transparent;\n  transition: all 0.18s ease;\n  letter-spacing: 0.01em;\n}\n\n.mode-tab:hover:not(:disabled) {\n  color: #111827;\n  background: #e5e7eb;\n  border-color: #d1d5db;\n}\n\n.mode-tab.mode-tab-active {\n  background: #6b7280;\n  border-color: #6b7280;\n  color: #fff;\n}\n\n.dark .mode-tab {\n  color: #cbd5e1;\n}\n\n.dark .mode-tab:hover:not(:disabled) {\n  color: #f9fafb;\n  background: #374151;\n  border-color: #4b5563;\n}\n\n.dark .mode-tab.mode-tab-active {\n  background: #e5e7eb;\n  border-color: #e5e7eb;\n  color: #111827;\n}\n\n.mode-selector-container--inline .mode-selector-panel {\n  width: 100%;\n  padding: 0.1rem 0 0;\n  gap: 0.5rem;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n  transform: none;\n  transform-origin: center top;\n}\n\n.mode-selector-container--docked .mode-selector-panel {\n  width: 100%;\n  padding: 0.1rem 0 0;\n  gap: 0.5rem;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n  isolation: isolate;\n}\n\n.mode-selector-container--docked .mode-selector-panel::before {\n  content: \"\";\n  position: absolute;\n  inset: -0.8rem -0.5rem -1.38rem;\n  z-index: -1;\n  box-sizing: border-box;\n  border-radius: 10px 10px 0 0;\n  border: 1px solid #e5e7eb;\n  border-bottom: 0;\n  background: var(--surface-color);\n}\n\n.dark .mode-selector-container--docked .mode-selector-panel::before {\n  border-color: #374151;\n  background: #1f2937;\n}\n\n.mode-bar-header {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n}\n\n.mode-bar-header-spacer {\n  justify-self: start;\n  width: 6rem;\n  height: 1px;\n}\n\n.mode-bar-toggle-placeholder {\n  justify-self: end;\n  width: 6rem;\n  height: 28px;\n}\n\n.mode-selector-container--inline .mode-bar-title,\n.mode-selector-container--docked .mode-bar-title {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  font-size: 0.72rem;\n  letter-spacing: 0.14em;\n  color: #475569;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.mode-selector-container--inline .mode-bar-title::before,\n.mode-selector-container--inline .mode-bar-title::after,\n.mode-selector-container--docked .mode-bar-title::before,\n.mode-selector-container--docked .mode-bar-title::after {\n  content: \"\";\n  display: block;\n  flex: 0 0 4.25rem;\n  width: 4.25rem;\n  height: 1px;\n  background: rgba(148, 163, 184, 0.9);\n}\n\n.dark .mode-selector-container--inline .mode-bar-title,\n.dark .mode-selector-container--docked .mode-bar-title {\n  color: #d8e0ea;\n}\n\n.dark .mode-selector-container--inline .mode-bar-title::before,\n.dark .mode-selector-container--inline .mode-bar-title::after,\n.dark .mode-selector-container--docked .mode-bar-title::before,\n.dark .mode-selector-container--docked .mode-bar-title::after {\n  background: rgba(148, 163, 184, 0.72);\n}\n\n.mode-selector-container--inline .mode-bar-buttons,\n.mode-selector-container--docked .mode-bar-buttons {\n  gap: 0.2rem;\n  flex-wrap: nowrap;\n  justify-content: center;\n  width: 100%;\n}\n\n.mode-selector-container--inline .mode-tab,\n.mode-selector-container--docked .mode-tab {\n  flex: 1 1 0;\n  min-width: 0;\n  padding: 0.42rem 0.45rem;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  background: transparent;\n  color: #4b5563;\n  font-size: clamp(0.76rem, 1.15vw, 0.88rem);\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n}\n\n.mode-selector-container--inline .mode-tab:hover:not(:disabled),\n.mode-selector-container--docked .mode-tab:hover:not(:disabled) {\n  color: #111827;\n  background: #e5e7eb;\n  border-color: #d1d5db;\n}\n\n.mode-selector-container--inline .mode-tab.mode-tab-active,\n.mode-selector-container--docked .mode-tab.mode-tab-active {\n  background: #6b7280;\n  border-color: #6b7280;\n  color: #fff;\n}\n\n.dark .mode-selector-container--inline .mode-tab,\n.dark .mode-selector-container--docked .mode-tab {\n  color: #cbd5e1;\n}\n\n.dark .mode-selector-container--inline .mode-tab:hover:not(:disabled),\n.dark .mode-selector-container--docked .mode-tab:hover:not(:disabled) {\n  color: #f9fafb;\n  background: #374151;\n  border-color: #4b5563;\n}\n\n.dark .mode-selector-container--inline .mode-tab.mode-tab-active,\n.dark .mode-selector-container--docked .mode-tab.mode-tab-active {\n  background: #e5e7eb;\n  border-color: #e5e7eb;\n  color: #111827;\n}\n\n.mode-selector-container--inline .mode-selector-divider,\n.mode-selector-container--inline .mode-selector-divider--section,\n.mode-selector-container--docked .mode-selector-divider,\n.mode-selector-container--docked .mode-selector-divider--section {\n  display: none;\n}\n\n/* ── Toggle button ── */\n\n.mode-bar-toggle {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 6px;\n  background: #e5e7eb;\n  color: #374151;\n  cursor: pointer;\n  padding: 0;\n  pointer-events: auto;\n  transition: all 0.2s ease;\n  margin-left: 0.4rem;\n}\n\n.mode-bar-toggle:hover {\n  background: #d1d5db;\n  transform: scale(1.05);\n}\n\n.dark .mode-bar-toggle {\n  background: #374151;\n  color: #d1d5db;\n}\n\n.dark .mode-bar-toggle:hover {\n  background: #4b5563;\n}\n\n.mode-bar-toggle-inline {\n  position: static;\n  justify-self: start;\n  transform: translateX(-1.55rem);\n  width: auto;\n  height: 28px;\n  gap: 0.28rem;\n  padding: 0 0.55rem 0 0.5rem;\n  margin-left: 0;\n  border: 1px solid #cbd5e1;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.92);\n  color: #334155;\n  opacity: 1;\n}\n\n.mode-bar-toggle-inline:hover {\n  background: #eef2f7;\n  border-color: #94a3b8;\n  color: #0f172a;\n  transform: translateX(-1.55rem);\n}\n\n.mode-bar-toggle-inline-label {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  line-height: 1;\n}\n\n.mode-bar-toggle-inline .collapse-icon {\n  width: 14px;\n  height: 14px;\n}\n\n.dark .mode-bar-toggle-inline {\n  background: rgba(30, 41, 59, 0.92);\n  border-color: #475569;\n  color: #d8e0ea;\n}\n\n.dark .mode-bar-toggle-inline:hover {\n  background: #334155;\n  border-color: #64748b;\n  color: #f8fafc;\n}\n\n.mode-bar-toggle-collapsed {\n  width: auto;\n  min-height: 32px;\n  padding: 0 0.85rem 0 0.7rem;\n  gap: 0.35rem;\n  margin-left: 0;\n  border-radius: 7px;\n}\n\n.mode-bar-toggle-label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  line-height: 1;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
